import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Puedes enviar el error a un servicio externo aquí si lo deseas
    console.error('ErrorBoundary atrapó un error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      let customMsg = this.state.error?.message;
      if (customMsg === 'useOtp must be used within an OtpProvider') {
        customMsg = 'Error interno: El sistema de autenticación OTP no está disponible. Por favor, recarga la página o contacta soporte.';
      }
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-red-900 text-white">
          <h1 className="text-2xl font-bold mb-4">¡Ha ocurrido un error inesperado!</h1>
          <p className="mb-2">{customMsg}</p>
          <button
            className="bg-white text-red-900 px-4 py-2 rounded"
            onClick={() => window.location.reload()}
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
} 